<template>
    <div style="text-align: -webkit-center; display: flex; justify-content: center;">
        
        <!-- <a class="store-container sears" href="https://wap-mesa-regalos.sears.com.mx/buscar?tipo=2&evento=22706921&page=1"  target="_blank">
            <div style="flex:1">
                <img src="../../public/img/mesaRegalos/sears.png" class="store-logos" />
            </div>
            <div style="flex:2; text-align: center">
                <div class="number"> <strong> Número: </strong> 22706921 </div>
            </div>
        </a> -->

        <a class="store-container liverpool" href="https://mesaderegalos.liverpool.com.mx/milistaderegalos/50059994"  target="_blank">
            <div style="flex:1; padding: 5px;">
                <img src="../../public/img/mesaRegalos/liverpool.png" class="store-logos" />
            </div>
            <div class="store-number">
                <div class="number"> <strong> Número: </strong> 50059994 </div>
            </div>
        </a>
        
    </div>
    
</template>

<script>
export default {
    
}
</script>


<style lang="scss" scoped>
@import "./variables.scss";

a {
    text-decoration: none;
}

.store-number {
    flex:2;
    font-size: 19px;
    text-align: center;
}

.store-container{
    // width: 50%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .number {
        font-size: 19px;
        @media screen and (max-width: $break-sm) {
            font-size: 15px;
        }
    }
    &:hover {
        color: white;
        .store-logos {
            filter: brightness(0) invert(1);
        }
    }
}

.liverpool {
    color: #D8007A;
    &:hover {
        background: #D8007A;
    }
}

.sears {
    color: #0052A0;
    &:hover {
        background: #0052A0;
    }
}

.store-logos {
    width: 200px;
}

</style>


